<template>
    <div class="c-graph">
        <icon
            v-if="svg"
            :icon="svg"
            class="c-graph__icon"
        />
        <div class="c-graph__content">
            <h3
                v-if="title"
                class="c-graph__title | t-t3-heavy"
            >
                {{ title }}
            </h3>
            <prismic-rich-text
                v-if="desc"
                class="c-graph__desc"
                :field="desc"
            />
        </div>
    </div>
</template>

<script>

import Icon from 'objects/Icon';
import PrismicRichText from 'objects/PrismicRichText';

export default {
    name: 'Card',
    components: {
        Icon,
        PrismicRichText,
    },
    props: {
        svg: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            default: '46',
        },
        desc: {
            type: Array,
        },
    },
};
</script>

<style lang="scss">

.c-graph {
    width: 100%;
    max-width: $card-max-width;
    padding-top: 2em;
    padding-bottom: 2em;
    color: $color-bright;

    @media #{$breakpoint-horizontal} {
        //max-width: 23em;
    }
}

.c-graph__icon {
    display: flex;
    align-items: center;
    width: 50%;
    max-width: 8em;
    height: auto;
    max-height: 8em;
    margin-bottom: 2em;
    text-align: left;

    svg {
        width: auto;
        max-width: 100%;
        height: auto;
        max-height: 100%;
    }

    svg {
        display: inline-block;
        fill: currentColor;
    }
}

.c-graph__title {
    margin-bottom: .5rem;
}

.c-graph__desc {}

</style>
